import { Pipe, PipeTransform } from "@angular/core";
import {
  DomSanitizer,
  SafeHtml,
  SafeStyle,
  SafeScript,
  SafeUrl,
  SafeResourceUrl
} from "@angular/platform-browser";

@Pipe({
  name: "safe"
})
export class SafePipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  public transform(
    value: any,
    type: string
  ): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    
    const linkTargetValue = value.toString().split('<a ').join('<a target="_new"');
    switch (type) {
      case "html":
        return this.sanitizer.bypassSecurityTrustHtml(linkTargetValue);
      case "style":
        return this.sanitizer.bypassSecurityTrustStyle(linkTargetValue);
      case "script":
        return this.sanitizer.bypassSecurityTrustScript(linkTargetValue);
      case "url":
        return this.sanitizer.bypassSecurityTrustUrl(linkTargetValue);
      case "resourceUrl":
        return this.sanitizer.bypassSecurityTrustResourceUrl(linkTargetValue);
      default:
        throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}
